import Logo from "../assets/techkshetra_final.png";
import { Link } from "react-router-dom";
import "../App.css";

const Header = () => {
  return (
    <nav className="flex fixed w-full top-0 uppercase justify-between items-center h-24 bg-black border-b border-gray-600 smm:text-center z-[80]">
      <div class="nav-div">
        <Link to="/">
          <img className="h-16 smm:h-8 sm:h-10" src={Logo} alt="logo" />
        </Link>
      </div>
      <div className="flex sm:items-center">
        <ul className="flex sm:items-center">
          <li>
            <Link
              to="/workshop"
              className="block p-4 mx-6 link link-underline link-underline-black md:mx-1 smm:text-[12px] smm:px-0 sm:text-[13px]"
            >
              Workshops
            </Link>
          </li>
          <li>
            <Link
              to="/technical"
              className="block p-4 mx-6 link link-underline link-underline-black md:mx-1 smm:text-[12px] smm:px-0 sm:text-[13px]"
            >
              Technical
            </Link>
          </li>
          <li>
            <Link
              to="/nontechnical"
              className="block text-center p-4 mx-6 link link-underline link-underline-black md:mx-1 smm:text-[12px] smm:px-0 sm:text-[13px]"
            >
              Non Technical
            </Link>
          </li>


        </ul>
      </div>
    </nav>
  );
};

export default Header;
